import { useState } from 'react';
import { useNamespaceCopy } from '@/i18n/ns';
import meetingsRecordCopy from '@/i18n/ns/meetings-record';
import { MeetingAudioInput, audioSelectionReady, emptyAudioSelection } from './meeting-audio-input';
import { MeetingDialog, MeetingDialogTitle } from './meeting-dialog';
import { meetingRecorder, useMeetingRecorder } from './meeting-recorder';
import { meetingRecorderDeps } from './meeting-recorder-deps';
import { useMeetingCaptureSupport } from './meeting-capture-support';
import { rememberMeetingAudioPreferences } from './meeting-audio-preferences';

/** Recovery revalidates explicit inputs, never substituting the default. */
export function ResumeRecordingButton() {
  const copy = useNamespaceCopy(meetingsRecordCopy);
  const sources = useMeetingRecorder((state) => state.recovery?.sources);
  const system = Boolean(sources?.includes('system'));
  const both = Boolean(sources?.includes('mic'));
  const support = useMeetingCaptureSupport();
  const desktopSystem = Boolean(support?.desktopSystem && !meetingRecorderDeps()?.isMobile());
  const [open, setOpen] = useState(false);
  const [selection, setSelection] = useState(emptyAudioSelection);
  const resume = () => {
    setOpen(false);
    void meetingRecorder.resume(selection.systemDeviceId, selection.microphoneDeviceId).then(() => {
      if (meetingRecorder.store.getState().phase !== 'recording') return;
      rememberMeetingAudioPreferences({
        source: both ? 'both' : system ? 'tab' : 'room',
        selection,
      });
    });
  };
  return (
    <>
      <button
        className="ws-button primary"
        onClick={() => {
          if (system && !desktopSystem) {
            setSelection(emptyAudioSelection());
            setOpen(true);
          } else void meetingRecorder.resume();
        }}
      >
        {copy.resume}
      </button>
      {open && (
        <MeetingDialog label={copy.resume} portal onClose={() => setOpen(false)}>
          <header>
            <MeetingDialogTitle>{copy.resume}</MeetingDialogTitle>
          </header>
          <div className="ws-meeting-dialog-body">
            <MeetingAudioInput both={both} value={selection} onChange={setSelection} />
          </div>
          <footer>
            <button className="ws-button" onClick={() => setOpen(false)}>
              {copy.cancel}
            </button>
            <button
              className="ws-button primary"
              disabled={!audioSelectionReady(selection, both)}
              onClick={resume}
            >
              {copy.resume}
            </button>
          </footer>
        </MeetingDialog>
      )}
    </>
  );
}
